import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export enum HowToWinLinkLocation {
    Banner = 'Banner',
    Footer = 'Footer',
    NavHeader = 'Nav Header',
}

type TrackHowToWinClickedPayload = TrackingPayload & {
    linkLocation: HowToWinLinkLocation;
};

export const trackHowToWinClickedAnalytics = (payload: TrackHowToWinClickedPayload) => {
    track(TrackingEvents.HowToWin.HowToWinClicked, payload);
};

export const useTrackHowToWinClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (linkLocation: HowToWinLinkLocation) => {
            trackHowToWinClickedAnalytics({
                linkLocation,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
